var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("img", {
    staticClass: "loading-icon",
    attrs: { src: "/svg/icons/ic_loading.svg", alt: "Loading" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./resources/js/Components/shared/LoadingIcon.vue